import { useEffect } from "react";
import { Routes, useLocation } from "react-router-dom";
import "./AnimatedRoutes.css";

const AnimatedRoutes = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="justo-page-transition-wrap">
      <div key={location.pathname} className="justo-page-transition">
        <Routes location={location}>{children}</Routes>
      </div>
    </div>
  );
};

export default AnimatedRoutes;
